import { render, staticRenderFns } from "./CustomerComplaint.vue?vue&type=template&id=1647d2a6&scoped=true&"
import script from "./CustomerComplaint.vue?vue&type=script&lang=ts&"
export * from "./CustomerComplaint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1647d2a6",
  null
  
)

export default component.exports